import { useSession } from "../state/SessionProvider";

type FlowNavProps = {
  /** Logical prior QuietVia view, or / from a mode hub. Omit on site root. */
  onBack?: () => void;
  /** Clears active-flow transient state and returns to /. Omit on root and mode hubs. */
  onHome?: () => void;
};

/**
 * Minimal contextual navigation — not breadcrumbs.
 * Labels stay generic (← Back / Home) so they do not expose journey history.
 * Arrow is decorative (aria-hidden); visible text provides the accessible name.
 */
export function FlowNav({ onBack, onHome }: FlowNavProps) {
  const { translate } = useSession();

  if (!onBack && !onHome) {
    return null;
  }

  return (
    <nav className="flow-nav" aria-label={translate("nav.flow_label")}>
      {onBack ? (
        <button type="button" className="text-action flow-nav__back" onClick={onBack}>
          <span aria-hidden="true" className="flow-nav__arrow">
            ←{" "}
          </span>
          {translate("nav.back")}
        </button>
      ) : null}
      {onHome ? (
        <button type="button" className="text-action" onClick={onHome}>
          {translate("nav.home")}
        </button>
      ) : null}
    </nav>
  );
}
